import { PolicyDetailsData } from 'scenes/home/types';
import {
  AustralianState,
  PaymentFrequency,
  PolicyHolder,
} from 'scenes/common/types';
import { YesNoAnswer, YesNoDontKnowAnswer } from 'scenes/common/flows/types';
import {
  PostalAddressOption,
  TermsAndConditions,
} from 'scenes/common/flows/policyDetails/types';

export const defaultAddress = {
  address: '',
  addressLine1: '',
  addressLine2: '',
  postcode: '',
  state: AustralianState.ACT,
  suburb: '',
};

export const defaultPolicyHolder: PolicyHolder = {
  firstName: '',
  lastName: '',
  dob: '',
};

export const defaultHomePolicyDetails: PolicyDetailsData = {
  propertyInGoodCondition: YesNoAnswer.Unspecified,
  heritageListed: YesNoAnswer.Unspecified,
  rewiredOrReplumbed: YesNoDontKnowAnswer.Unspecified,
  propertyUnoccupied: YesNoAnswer.Unspecified,
  propertyRenovationCurrent: YesNoAnswer.Unspecified,
  propertyRenovationFuture: YesNoAnswer.Unspecified,
  over5Acres: YesNoAnswer.Unspecified,
  propertyOccupancy: YesNoAnswer.Unspecified,
  cashKeptAtHome: YesNoAnswer.Unspecified,
  stockKeptAtHome: YesNoAnswer.Unspecified,
  hazardGoodsKeptAtHome: YesNoAnswer.Unspecified,
  numberOfVisits: -1,
  businessRegisteredForGst: YesNoAnswer.Unspecified,
  historyDetails: [],
  mortgageProvider: '',
  mortgageProviderOther: '',
  businessName: '',
  abn: '',
  businessContactFirstName: '',
  businessContactLastName: '',
  personalContactFirstName: '',
  personalContactLastName: '',
  contactEmailAddress: '',
  contactPhoneNumber: '',
  addAdditionalPolicyHolder: YesNoAnswer.Unspecified,
  additionalPolicyHolders: [],
  postalAddressOption: PostalAddressOption.MainAddress,
  postalAddress: defaultAddress,
  lockedBoxAddress: defaultAddress,
  termsAndCondition: TermsAndConditions.Unspecified,
  preselectedPaymentFrequency: PaymentFrequency.Annually,
};
